import { HttpHandler } from 'msw'

import { createServiceReport } from './createServiceReport'
import { getAllServiceReports } from './getAllServiceReports'
import { getServiceReport } from './getServiceReport'

export const serviceReports: HttpHandler[] = [
    createServiceReport,
    getAllServiceReports,
    getServiceReport,
]
